import React from 'react';
import styled from 'styled-components';
import { whatsappLink } from '@config';
import { useLanguage } from '../context/language';

const StyledWhatsAppFab = styled.a`
  position: fixed;
  right: clamp(18px, 3vw, 28px);
  bottom: clamp(18px, 3vw, 28px);
  z-index: 60;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: 0;
  background: var(--portfolio-accent, var(--green));
  color: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.22);
  text-decoration: none;
  transition: var(--transition);

  &:hover,
  &:focus {
    transform: scale(1.06);
    color: #ffffff;
  }

  .badge {
    width: 100%;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
      width: 29px;
      height: 29px;
      fill: currentColor;
    }
  }

  .label {
    display: none;
  }
`;

const WhatsAppFab = () => {
  const { content } = useLanguage();
  const label = content.layout.whatsAppCta;
  const ariaLabel = content.layout.whatsAppAriaLabel;

  return (
    <StyledWhatsAppFab href={whatsappLink} aria-label={ariaLabel}>
      <span className="badge" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M20.52 3.48A11.86 11.86 0 0012.07 0C5.52 0 .19 5.33.19 11.88c0 2.09.55 4.13 1.6 5.93L0 24l6.35-1.66a11.82 11.82 0 005.72 1.46h.01c6.55 0 11.88-5.33 11.88-11.88 0-3.17-1.23-6.15-3.44-8.44zm-8.45 18.3h-.01a9.95 9.95 0 01-5.08-1.39l-.36-.21-3.77.99 1.01-3.67-.23-.38a9.93 9.93 0 01-1.52-5.24c0-5.48 4.46-9.94 9.95-9.94 2.65 0 5.14 1.03 7.01 2.91a9.86 9.86 0 012.9 7.03c0 5.49-4.46 9.95-9.94 9.95zm5.45-7.43c-.3-.15-1.77-.88-2.05-.98-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.8-1.68-2.1-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.48-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.05 1.03-1.05 2.5 0 1.47 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.13 4.55.72.31 1.28.5 1.72.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.18-1.42-.07-.12-.27-.2-.57-.35z" />
        </svg>
      </span>

      <span className="label">
        <span>{label}</span>
      </span>
    </StyledWhatsAppFab>
  );
};

export default WhatsAppFab;
